import type { MatchConfig } from '../proto';

export const MODE_PRESETS = [
  { id: 'sequential', label: '交互', hint: '1つの時計で、左から1巡ずつ交代', orchestrator: 'Sequential', scope: 'Whole' },
  { id: 'parallel', label: '同時', hint: '1つの時計で、左から進む。追い越しなし', orchestrator: 'Parallel', scope: 'Whole' },
  { id: 'multi', label: '各盤', hint: '盤ごとの時計で、手番の盤を自由に選ぶ', orchestrator: 'FullyParallel', scope: 'PerBoard' },
] as const;

export function modeIdForConfig(config: MatchConfig) {
  const scope = (config.clock as { scope?: string } | undefined)?.scope;
  return MODE_PRESETS.find(m => m.orchestrator === config.orchestrator && m.scope === scope)?.id
    ?? (config.orchestrator === 'Sequential' ? 'sequential' : config.orchestrator === 'FullyParallel' ? 'multi' : 'parallel');
}

export function ModeIcon({ id }: { id: typeof MODE_PRESETS[number]['id'] }) {
  return <svg viewBox="0 0 48 36" width="48" height="36" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    {[5, 19, 33].map(x => <rect key={x} x={x} y="10" width="10" height="10" rx="1"/>)}
    {id === 'multi' ? [10,24,38].map(x => <g key={x}><circle cx={x} cy="28" r="4"/><path d={`M${x} 25.5v2.5l1.5 1`}/></g>) : <>
      <path d={id === 'parallel' ? 'M6 5h18m-4-3 4 3-4 3' : 'M6 5h36m-4-3 4 3-4 3'}/>
      <path d={id === 'parallel' ? 'M24 26h18m-4-3 4 3-4 3' : 'M6 26h36m-4-3 4 3-4 3'}/>
      <circle cx="24" cy="32" r="3"/><path d="M24 30v2l1 1"/>
    </>}
  </svg>;
}

export function ModePicker({ config, onChange, isHost = true }: { config: MatchConfig; onChange: (config: MatchConfig) => void; isHost?: boolean }) {
  const current = modeIdForConfig(config);
  return <div className="mode-picker">
    <div className="mode-options" role="group" aria-label="進行モード">
      {MODE_PRESETS.map(m => <button type="button" key={m.id} className={`mode-option ${current === m.id ? 'active' : ''}`} disabled={!isHost} aria-pressed={current === m.id} aria-label={`${m.label}。${m.hint}`} title={m.hint} data-testid={`mode-${m.id}`} onClick={() => onChange({ ...config, orchestrator: m.orchestrator, clock: { ...((config.clock ?? {}) as Record<string, unknown>), scope: m.scope } })}>
        <ModeIcon id={m.id}/><span className="mode-label">{m.label}</span>
      </button>)}
    </div>
    <p className="mode-hint">{MODE_PRESETS.find(m => m.id === current)!.hint}</p>
  </div>;
}
